// Hexo 靠扫描 source/_posts 目录建立文章列表；浏览器没法列目录，所以这里
// 手写一份清单。新增一篇文章 = 往 public/posts/ 放一个 .md，再在这里加一行。
// 顺序无所谓，页面按 front-matter 里的 date 倒序排。
export const postSlugs = [
  'daxigua',
];

export const postPath = (slug) => `${process.env.PUBLIC_URL}/posts/${slug}.md`;
